import React from "react";
import { Box, Typography } from "@mui/material";

function TinyWinBanner({ text, sx }) {
  if (!text) return null;

  return (
    <Box
      sx={[
        {
          borderRadius: 2,
          border: "1px solid",
          borderColor: "#bbf7d0",
          backgroundColor: "#ecfdf5",
          px: 1.5,
          py: 1.25,
        },
        sx,
      ]}
    >
      <Typography variant="caption" sx={{ fontWeight: 700, color: "#166534" }}>
        {text}
      </Typography>
    </Box>
  );
}

export default TinyWinBanner;
